import { toast } from "react-toastify";
import API from "./../../helpers/api/api_interceptor";
import { SET_TASK_LIST } from "./actionType";

// list all permissoins
export const getTaskLists = (params) => async (dispatch) => {
  try {
    return API.get(`/homes/tasks`, {
      params: {
        page_number: params.page,
        page_size: params.limit,
        search: params.search,
        filter: params.filter,
        sort: params.sort,
      },
    }).then((res) => {
      if (res && res.status && res.status === 200) {
        dispatch({
          type: SET_TASK_LIST,
          payload: {
            data: res?.data?.data?.results,
            total: res?.data?.data?.count,
          },
        });
        return true;
      } else {
        return false;
      }
    });
  } catch (error) {
    console.log(error);
  }
};

// create tasks
export const createTask = (payload) => async (dispatch) => {
  try {
    return API.post(`/homes/tasks`, payload).then((res) => {
      if (res && res.status && res.status === 201) {
        toast.success(res?.data?.detail);
        return true;
      } else {
        return false;
      }
    });
  } catch (error) {
    console.log(error);
  }
};

// update tasks
export const updateTask =
  ({ id, values }) =>
  async (dispatch) => {
    try {
      return API.put(`/homes/tasks/${id}`, values).then((res) => {
        if (res && res.status && res.status === 200) {
          toast.success(res?.data?.detail);
          return true;
        } else {
          return false;
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

// delete tasks
export const deleteTask = (id) => async (dispatch) => {
  try {
    return API.delete(`/homes/tasks/${id}`).then((res) => {
      if (res && res.status && res.status === 200) {
        toast.success(res?.data?.detail);
        return true;
      } else {
        return false;
      }
    });
  } catch (error) {
    console.log(error);
  }
};
